const NAME = "PUBLICATION_SETTINGS";

export const TYPES_USES_LINK_AND_DOWNLOAD = ["M", "B", "C"];
export const TYPES_USES_NUMBER = ["C"];
export const TYPES_USES_ONLY_LINK = ["U"];
export const TYPES_USES_ONLY_DOWNLOAD = ["L"];
export const TYPES_NEEDS_IMAGE = ["B"];

export default NAME;
